export default __webpack_public_path__ + "static/images/intro.c2acfbb8.png";